import { Table, Button, Modal, Row, Col, InputNumber } from 'antd/lib';
import React from 'react';
import moment from 'moment';
import _ from 'lodash';

class TablaTipoSellos extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filterDropdownVisible: false,
      verFiltroApellido: false,
      data: this.props.certificaciones,
      textoBuscarNombre: '',
      textoBuscarApellido: '',
      textoBuscarDocumento: '',
      filtered: false,
      selloElegido: '',
      visible: false,
      valores: [],
    };
  }

  showModal = _id => {
    // console.log('ELEGI: ', _id);

    /* armamos los valores */
    let val = [];

    let index = _.findIndex(this.props.tiposSellos, elem => {
      return elem._id == _id;
    });

    let limitesViejos = this.props.tiposSellos[index].limites;

    if (limitesViejos) {
      _.each(limitesViejos, elem => {
        val[elem.organismo._id] = elem.limite;
      });
    }

    // console.log('QUEDAN LOS VALORES: ');
    // console.log(val);

    this.setState({
      visible: true,
      selloElegido: _id,
      valores: val,
    });
  };

  handleOk = () => {
    this.setState({
      visible: false,
    });

    this.props.enviarDatos(this.state.selloElegido, this.state.valores);
  };

  handleCancel = () => {
    this.setState({
      visible: false,
      valores: [],
    });
  };

  render() {
    const columns = [
      {
        title: 'Nombre',
        dataIndex: 'nombre',
        key: 'nombre',
        // defaultSortOrder: 'ascend',
        sorter: (a, b) => a.nombre.localeCompare(b.nombre),
      },
      {
        title: 'Valor',
        dataIndex: 'valor',
        key: 'valor',
        render: text => '$' + text,
        sorter: (a, b) => a >= b,
      },
      {
        title: 'Desde',
        dataIndex: 'vigenteDesde',
        key: 'desde',
        render: fecha =>
          fecha ? moment(fecha).format('DD/MM/YYYY') : 'SIN DATOS',
        defaultSortOrder: 'descend',
        sorter: (a, b) => new Date(a.vigenteDesde) - new Date(b.vigenteDesde),
      },
      {
        title: 'Hasta',
        dataIndex: 'vigenteHasta',
        key: 'hasta',
        render: fecha =>
          fecha ? moment(fecha).format('DD/MM/YYYY') : 'SIN DATOS',
      },
      {
        title: 'Acciones',
        render: fila => (
          <Button
            type="primary"
            onClick={() =>
              this.props.history.push(`/admin/otros/tipo_sello/${fila._id}`)
            }
          >
            Configurar
          </Button>
        ),
      },
    ];
    const { tiposSellos } = this.props;
    return (
      <React.Fragment>
        <Table
          rowKey="_id"
          columns={columns}
          dataSource={tiposSellos}
          title={() => <h2 style={{ textAlign: 'center' }}> Tipos Sellos </h2>}
          locale={{
            emptyText: 'No hay tipos de sellos cargados',
          }}
        />

        <Modal
          title="Configuracion de Limite de Alerta"
          visible={this.state.visible}
          onOk={this.handleOk}
          width={500}
          onCancel={this.handleCancel}
        >
          {/* <Select
            style={{ width: 400 }}
            id="organismos"
            // mode="multiple"
            placeholder="Seleccione los organismos"
            value={this.state.organismoSeleccionado}
          >
            {this.props.organismos &&
              this.props.organismos.map(organismo => (
                <Select.Option key={organismo._id}>{organismo.nombre}</Select.Option>
              ))}
          </Select> */}

          {this.props.organismos &&
            this.props.organismos.map(organismo => {
              if (organismo.nombre.indexOf('JUZGADO') > -1) {
                return (
                  <Row
                    type="flex"
                    align="middle"
                    key={organismo._id}
                    style={{ margin: 20 }}
                  >
                    <Col span={18}> {organismo.nombre.toUpperCase()}</Col>
                    <Col>
                      <InputNumber
                        min={1}
                        value={this.state.valores[organismo._id]}
                        onChange={value => {
                          let nuevoArreglo = this.state.valores;
                          nuevoArreglo[organismo._id] = value;
                          this.setState({
                            valores: nuevoArreglo,
                          });
                        }}
                      />
                    </Col>
                  </Row>
                );
              } else {
                return null;
              }
            })}
        </Modal>
      </React.Fragment>
    );
  }
}

export default TablaTipoSellos;
